<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #decisionCodeName
                        label="Decision code name"
                        placeholder="Please, write a decision code name"
                        baseCypressTag="business-settings-decision-code-modal-name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="100"
                        [validators]="validators.name"
                        [messages]="nameMessages"
                        (inputValueChange)="nameInputChange($event)"></app-input-text>

        <app-input-text #decisionCode
                        label="Decision code"
                        placeholder="Please, write a decision code, e.g. 00"
                        baseCypressTag="business-settings-decision-code-modal-code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="2"
                        [validators]="validators.code"
                        [messages]="codeMessages"
                        (inputValueChange)="codeInputChange($event)"></app-input-text>

        <app-input-multi-select #selfExclusion
                                label="Self-exclusion"
                                placeholder="Please, select one or more decision code(s)"
                                baseCypressTag="business-settings-decision-code-modal-excluded-codes"
                                [labelInformation]="selfExclusionInfo"
                                [options]="selfExclusionOptions"
                                (inputValueChange)="selfExclusionInputChange($event)"></app-input-multi-select>

        <div fieldset id="hasTimeEffort-input-form" class="modal-radio-input">

            <div class="modal-info-label"
                 data-cy="business-settings-decision-codes-hasTimeEffort-label">Requires time effort (TE minutes)?</div>

            <div class="modal-radio-input-option">
                <input type="radio" id="yes" name="hasTimeEffort"
                       (change)="hasTimeEffortInputChange(true)"
                       [checked]="$safeNavigationMigration(state?.currentValue?.hasTimeEffort)"
                       data-cy="business-settings-decision-code-modal-radio-button-yes">
                <label for="yes" class="modal-radio-input-label">Yes</label>
            </div>
            <div class="modal-radio-input-option">
                <input type="radio" id="no" name="hasTimeEffort"
                       (change)="hasTimeEffortInputChange(false)"
                       [checked]="!state?.currentValue?.hasTimeEffort"
                       data-cy="business-settings-decision-code-modal-radio-button-no">
                <label for="no" class="modal-radio-input-label">No</label>
            </div>
        </div>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>
</app-generic-modal>


<ng-template #selfExclusionInfo>
    <app-tooltip [tooltipType]="tooltipTypeEnum.INFORMATION"
                 message="Choices made in this field will exclude each other as a decision code possibility for the second and further position(s) on a claim."></app-tooltip>
</ng-template>
